export default __webpack_public_path__ + "static/media/logo-mp.73b4202c.png";